<template lang="html">

  <div class="aviso-legal">

    <section class="intro-legales column-center launch">

      <h1 class="subtitle-intro">
        <span>{{$t("intros_legales.aviso_legal")}}</span>
      </h1>

    </section> 

    <section class="textos-legales container">
      <h2>{{$t("aviso_legal.terminos")}}</h2>


<p>{{$t("aviso_legal.uno")}}</p>

<p>{{$t("aviso_legal.dos")}}</p>

<p>{{$t("aviso_legal.tres")}}</p>

<p>{{$t("aviso_legal.cuatro")}}</p>
<p>{{$t("aviso_legal.cuatro_dos")}}</p>
<p>{{$t("aviso_legal.cinco")}}</p>

<p>{{$t("aviso_legal.seis")}}</p>

<p>{{$t("aviso_legal.seis_uno")}}</p>
<p>{{$t("aviso_legal.seis_dos")}}</p>
<p>{{$t("aviso_legal.seis_tres")}}</p>
<p>{{$t("aviso_legal.seis_cuatro")}}</p>
<p>{{$t("aviso_legal.seis_cinco")}}</p>
<p>{{$t("aviso_legal.seis_seis")}}</p>
<p>{{$t("aviso_legal.siete")}}</p>

<p>{{$t("aviso_legal.ocho")}}</p>

<p>{{$t("aviso_legal.nueve")}}</p>

<p>{{$t("aviso_legal.diez")}}</p>

<p>{{$t("aviso_legal.diez_uno")}}</p>
<p>{{$t("aviso_legal.once")}}</p>

<p>{{$t("aviso_legal.doce")}}</p>

<p>{{$t("aviso_legal.doce_uno")}}</p>

  
    </section>

  </div>

</template>

<script lang="js">
  export default  {
    name: 'politica-de-cookies',
  }
</script>




// WEBPACK FOOTER //
// src/components/views/aviso-legal.vue